import { jsx } from "react/jsx-runtime";
import { useClassNameFactory, ColorSchemeProvider } from "@contember/react-utils";
import { colorSchemeClassName } from "@contember/utilities";
import { memo, forwardRef } from "react";
import { toStateClass } from "../../utils/toStateClass.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
const HoveringToolbar = memo(forwardRef(({
  isActive,
  scope,
  scheme,
  children
}, ref) => {
  const componentClassName = useClassNameFactory("hoveringToolbar");
  return /* @__PURE__ */ jsx(ColorSchemeProvider, { scheme: scheme ?? "dark", children: /* @__PURE__ */ jsx(
    "div",
    {
      className: componentClassName(null, [
        toStateClass("active", isActive),
        toEnumViewClass(scope),
        colorSchemeClassName(scheme ?? "dark")
      ]),
      ref,
      children: /* @__PURE__ */ jsx("div", { className: componentClassName("content"), children })
    }
  ) });
}));
HoveringToolbar.displayName = "HoveringToolbar";
export {
  HoveringToolbar
};
//# sourceMappingURL=HoveringToolbar.js.map
